import { apiClient } from '@/shared/lib/axios';
import { PaymentMethod } from '@/types/admin-clinic-info';
import { useQuery } from '@tanstack/react-query';

type Response<T> = {
  data: T[];
};

export const getBankPayment = async (siteType: string | null): Promise<Response<PaymentMethod>> => {
  const response = await apiClient.get<Response<PaymentMethod>>(
    `/admin/${siteType}/master-data/bank-payment-types`
  );
  return response.data;
};

export const useAdminBankPayment = (siteType: string | null) => {
  return useQuery({
    queryKey: ['bank-payment', siteType],
    queryFn: () => getBankPayment(siteType),
  });
};
